<template>
  <div v-show="displayPDF" class="full-page">
    <b-icon-x class="close-icon" @click="showPDF(false)"></b-icon-x>
    <b-button variant="success" class="pdf-btn" @click="saveFile">Save PDF</b-button>
    <div class="container" style="height: 100%">
      <iframe height="100%" width="100%" :src="pdfDataUri" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "display-pdf",
  data() {
    return {};
  },
  methods: {
    saveFile() {
      this.pdfDoc.save(this.pdfFileName);
    },
    ...mapMutations(["showPDF"]),
  },
  computed: {
    ...mapGetters(["displayPDF", "pdfDataUri", "pdfDoc", "pdfFileName"]),
  },
};
</script>

<style lang="scss" scoped>
.pdf-btn {
  float: right;
  margin-top: 5em;
}
</style>
